import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {AngularFirestore} from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-modal',
    templateUrl: 'home.component.dialog.html',
    styleUrls: ['home.component.scss']
})
export class DialogOverviewExampleDialogComponent {

    private REST_API_SERVER = 'https://us-central1-alliancecourses.cloudfunctions.net/getRegistrationDate';
    arrayToUse = this.data.dayArray;

    constructor(
        private db: AngularFirestore,
        public dialog: MatDialog,
        private httpClient: HttpClient,
        public dialogRef: MatDialogRef<DialogOverviewExampleDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
          this.sendGetRequest().subscribe((dataHttp: any[]) => {
            if (JSON.stringify(dataHttp) !== JSON.stringify(this.arrayToUse)) {
              this.arrayToUse = dataHttp;
            }
          });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    sendGetRequest() {
      return this.httpClient.get(this.REST_API_SERVER);
    }

    onDateValid = (stringDate: string) => {
      let mappedDate = '';
      const splittedDate = stringDate.split('/');
      if (splittedDate.length === 3) {
        mappedDate = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
      }

      const classDate = new Date(mappedDate);
      const today = new Date();
      classDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      console.log('time', classDate);
      return classDate >= today;
    }

    onRegisterClick = (item: any) => {
      if (!item.likers.includes(item.user)) {
            this.db.collection('tickets').doc(this.data.uid).update({
                likers: firebase.firestore.FieldValue.arrayUnion(item.user)
            });
        }
      if (item.likers.includes(item.user)) {
            this.db.collection('tickets').doc(this.data.uid).update({
                likers: firebase.firestore.FieldValue.arrayRemove(item.user)
            });
        }
      this.dialogRef.close();
    }

}
